import { GpsRequest } from './../interfaces/gps-request.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GpsResponse } from '@interfaces/gps-response.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GpsService {
  constructor(private http: HttpClient) {}

  solicitarGps(gpsRequest: GpsRequest): Observable<GpsResponse> {
    return this.http.post<GpsResponse>('/gps', gpsRequest);
  }
}
